import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const sponsorCardStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	borderRadius: '12px',
	backgroundColor: Colors.white_a5,
	border: `1px solid ${Colors.white_a10}`,
	p: '16px',
	pb: 'calc(16px + 24px)',
	position: 'relative',
};

export const avatarBox: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};

export const avatarStyles: SxProps<Theme> = {
	flexShrink: 0,
	borderRadius: '50%',
	width: '140px',
	height: '140px',
	border: '1.029px dashed #252525',
	backgroundColor: Colors.white_a5,
};

export const inputsBox: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
};

export const dragAndDropIconStyles: SxProps<Theme> = {
	width: '18px',
	height: '18px',
	position: 'absolute',
	top: '8px',
	left: '8px',
	color: Colors.white,

	'& >svg': {
		width: '100%',
		height: '100%',
	},
};
